<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component v-if="item.name === '1'" :is="item.content" :ref="item.ref" @addTab="addTab()" @removeTab="removeTab(item.name)"></component>
      <component v-else :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor="26"></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import filters from '../method/filter.js'
import {mapState} from 'vuex'
import DmkyLB from '../assembly/DmkyLB.vue'
import KyzxLB from '../assembly/KyzxLB.vue'
import KyzhLb from '../assembly/KyzhLb.vue'
import SjgxLB from '../assembly/SjgxLB.vue'
import DxzlLB from '../assembly/DxzlLB.vue'
import ComboBox from '../assembly/ComboBox.vue'
import Classification from '../assembly/Classification.vue'
export default {
  mixins: [filters],
  components: {
    DmkyLB,
    KyzxLB,
    KyzhLb,
    SjgxLB,
    DxzlLB,
    ComboBox,
    Classification
  },
  data()
  {
    return {
      selectList:
      [
        {value: 'type', name: '所属分类', parentdispc: '', dispc: '', tableData: []}
      ],
      //tab页默认选中
      activeName: 'second',
      editableTabsValue: '1',
      editableTabs: [
        {
          title: '矿业资讯审核列表',
          name: '1',
          closable: false,
          content: KyzxLB
        },
        {
          title: '东盟矿业审核列表',
          name: '2',
          closable: false,
          content: DmkyLB
        },
        {
          title: '矿业展会审核列表',
          name: '3',
          closable: false,
          content: KyzhLb
        },
        {
          title: '数据共享审核列表',
          name: '4',
          closable: false,
          content: SjgxLB
        },
        {
          title: '资料库审核列表',
          name: '5',
          closable: false,
          content: DxzlLB
        }
      ]
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName,
      nodeid: state => state.NavID
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.activeName = nval.activeName
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //添加下拉值
    onSubmit(obj)
    {
      let params =
      {
        cmd: 'add',
        _major: 99,
        _minor: 20,
        retAtt: 1,
        moduleid: this.nodeid,
        dispc: obj.dispc,
        colname: obj.value,
        major: 11,
        minor: 26,
        glid: obj.parentdispc || 0
      }
      window.post.getPost(params).then(res =>
      {
        if (res instanceof Object)
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
      })
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/TokyExamine.vue